import { atom } from "jotai";

export const OverlayLoading_atom = atom<boolean>(false);
